// extracted by mini-css-extract-plugin
module.exports = {"clearButton":"facet-ActiveFacetsByGroup__clearButton--1kZuX"};